export enum FastAccessFilterEnum {
  HAS_PROGRESSIVE = "hasProgressive",
  CAMPAIGN = "campaign",
}
